import {
  type SystemWithCapacity,
  type AddSystemRequest,
  type UpdateSystemRequest,
  type AddSystemResponse
} from '@bliks-io/contracts';
import { ENTITY_ICONS } from '@/constants/entityIcons';
import { useSystems } from '@/api/queries/useSystems';
import { useCreateSystem, useUpdateSystem, useDeleteSystem } from '@/api/mutations/useSystems';
import { usePermissions } from '@/hooks/usePermissions';
import { OrganizationTabsNav } from '@/components/organization/OrganizationTabsNav';
import {
  createEntityListPage,
  type EntityListPageDescriptor
} from '@/components/entity-list/EntityListPage';
import { SystemFormDialog } from './components/SystemFormDialog';
import { useSystemListColumns } from './components/useSystemListColumns';

export const systemsDescriptor: EntityListPageDescriptor<
  SystemWithCapacity,
  AddSystemRequest,
  UpdateSystemRequest,
  AddSystemResponse
> = {
  documentTitleKey: 'pageTitles.systems',
  i18nPrefix: 'organization.systems',
  icon: ENTITY_ICONS.system,
  TabsNav: OrganizationTabsNav,
  tableId: 'systems',
  enableGlobalFilter: true,
  useRows: () => useSystems(),
  useMutations: () => {
    const { can } = usePermissions();
    const create = useCreateSystem();
    return {
      create: can('System', 'create') ? create : undefined,
      update: useUpdateSystem(),
      remove: useDeleteSystem()
    };
  },
  useColumns: useSystemListColumns,
  renderFormDialog: ({ open, onOpenChange, entity, onSubmit }) => (
    <SystemFormDialog
      open={open}
      onOpenChange={onOpenChange}
      // The dialog chains the logo upload onto the created system.
      onSubmit={(data) => onSubmit(data).then((result) => result?.data)}
      system={entity}
    />
  ),
  deleteEntityPhraseKey: 'organization.systems.deletePhrase'
};

export const SystemsListPage = createEntityListPage(systemsDescriptor);
